/**
 * @module
 * the app is responsible for global events and
 * responsibilities.
 */

const selector = '[data-js-misc-slider]';
const slider = function (el, app) {

    const $el = $(el);
    const $setRange = $el.find('[data-js-misc-slider-update]');
    const $setInput = $el.find('[data-js-misc-slider-value]');
    // elements equivalent pop-over
    const $setEquivalent = $el.find('[data-js-misc-slider-equiv]');
    const $setEquivalentShuttle = $el.find('[data-js-misc-slider-equiv-shuttle]');
    const $setEquivalentText = $el.find('[data-js-misc-slider-equiv-text]');
    const $setEquivalentArrow = $el.find('[data-js-misc-slider-equiv-arrow]');
    //range
    let rangeMax = parseInt($setRange.attr('max'));
    const rangeMaxData = $setRange.attr('data-misc-slider-range-max');
    let rangeMin = parseInt($setRange.attr('min'));
    const rangeMinData = $setRange.attr('data-misc-slider-range-min');

    const rangeValueData = $setRange.attr('data-misc-slider-range-default');

    const noEquiv = $el.attr("data-js-misc-slider-hide-equiv") === "true";

    // other
    const $setaxis = $el.find('[data-js-misc-slider-axis]');
    const $setaxisIcons = $el.find('[data-js-misc-slider-axis-icon]');
    let highValPopped = false;

    const equivWidth = 230;
    let rangeWidth = 0;
    let windowWidth = 0;
    let rangeValStart = 0; // when moving the range input, this holds the starting value
    let maxVal = 999999; // anything *equal or more* than this level triggers a pop-over asking the user to contact kundtjänst. set in the markup as a data-type [data-max-on-site].

    const init = function () {
        setDefaults();
        setUpForm();
        registerEvents();
        initEquiv();
        $(window).on('resize', function () {
            initEquiv();
        });

        el.interface = {
            getValue: function() {
                return $setInput.val();
            },
            setLimits: setLimits,
            setValue: setValue
        };

    };

    const setValue = function (value) {
        $setRange.val( value );
        rangeValStart = value;
        $setInput.val( value );
    };

    const setLimits = function (min, max) {
        $setRange.attr({
            "min": min,
            "max": max
        });
        $setInput.attr({
            "min": min
        });
        rangeMax = max;
        rangeMin = min;
    };

    const setDefaults = function () {

        const val = rangeValueData;
        const min = rangeMinData ? rangeMinData : rangeMin;
        const max = rangeMaxData ? rangeMaxData : rangeMax;
        $setInput.attr({
            "value": val,
            "min": min
        });
        $setRange.attr({
            "value": val,
            "min": min,
            "max": max
        });
        rangeMax = parseInt(max);
        rangeMin = parseInt(min);

        rangeValStart = val;
        maxVal = parseInt($setRange.attr('data-ny-misc-slider-range-contact'));
    };

    const setUpForm = function () {
        //$setRange.val(app.consumption);
        listenEquivalent();
    };

    const registerEvents = function () {

        $setRange.on('mousedown touchstart', rangeMousedown);
        // IE and EDGE are slooow at updating the input event, opt them out
        if (window.BROWSER_IE || window.BROWSER_EDGE || window.PLATFORM_ANDROID_PRECHROME) {
            $setRange.on('input', dumbEquiv);
            $setRange.on('change', rangeUpdate);
        } else {
            $setRange.on('input', rangeUpdate);
            $setRange.on('change', ev => { ev.stopPropagation(); });
        }
        $setRange.on('mouseup touchend touchcancel', rangeMouseup);

        $setRange.on('input', moveEquiv);
        $setRange.on('mousedown', showEquiv);
        $setRange[0].addEventListener('touchstart', showEquiv, true); // touchstart with passive event listener
        $setRange.on('mouseup touchend touchcancel', hideEquiv);

        $setInput.on('blur keyup', inputUpdate);
        $setInput.on('click', inputSelect);
        $setInput.on('blur', inputUnselect);
        $setInput.on('change', ev => { ev.stopPropagation(); });

        $setaxisIcons.on('click', axisClick);

        // kill the equiv pop-over if we need to (especially in a flip-over scenario in a ny-mini module)
        app.on('killAllPops', hideEquivInstant);

    };

    const notifyChange = function () {
        $el.trigger({ type: "change", value: $setInput.val() });
    };

    const notifyChanging = function () {
        $el.trigger({ type: "changing", value: $setInput.val() });
    };

    const rangeUpdate = function (ev) {
        $setInput.val(this.value);
        ev.stopPropagation();
        notifyChanging();
    };

    const rangeMousedown = function (ev) {
    };

    const rangeMouseup = function (ev) {
        $setInput.val(this.value);
        notifyChange();
    };

    const inputUpdate = function (ev) {
        let inputValue = this.value;
        const regex = /\D/;
        if (regex.test(inputValue)) {
            inputValue = inputValue.replace(/\D/g, '');
            $setInput.val(inputValue);
        }
        inputValue = parseInt(inputValue);
        if (!Number.isInteger(inputValue)) {
            const errorMsg = (typeof dictionaryNyConsumption !== 'undefined' ? dictionaryNyConsumption.numberError : '');
            app.trigger('msgGlobal', [errorMsg, 'consumptionError', 'error']);
            return;
        } else {
            app.trigger('msgGlobalKill', ['consumptionError']);
        }

        if (inputValue >= maxVal && !highValPopped) {

            // don't display a global notificication with a price attached.
            app.trigger('msgSilenceOn');
            // activate the modal message
            app.trigger('popPop', { popupTarget: '[data-js-popup-high-use]' } );
            // re-enable global notificication
            setTimeout(function () {
                app.trigger('msgSilenceOff');
            }, 100);
            highValPopped = true;
        }
        $setRange.val(inputValue);
        notifyChange();

        // if hitting the enter key after setting the value manually, close software keyboards.
        if (ev && ev.keyCode === 13) {
            $setRange.focus();
        }
    };

    // on clicking the value input, select the whole field, but on clicking a second time, allow normal selection (so you can change individual numbers)
    let inputSelected = false;
    const inputSelect = function (ev) {
        if (!inputSelected) {
            $setInput.select();
        }
        inputSelected = true;
    };

    const inputUnselect = function (ev) {
        inputSelected = false;
    };

    const axisClick = function (ev) {
        showEquiv(false, false);
        const prevVal = 0; // TODO Consumption = parseInt(app.consumption);
        const iconVal = parseInt($(this).attr('data-js-misc-slider-axis-icon'));

        /* RAF loop */
        const duration = 200;
        const frameRate = 16;
        const frames = Math.floor(duration / frameRate);
        const numberDif = iconVal - prevVal;
        const jumpPerFrame = numberDif / frames;
        var currentFrame = 0;
        var numberCurFlo = 0;
        var numberCurInt = numberCurFlo;
        var timeFinish = Date.now() + duration;
        function step(timestamp) {
            numberCurFlo += jumpPerFrame;
            numberCurInt = Math.round(prevVal + numberCurFlo);

            // end of animation
            if (numberCurInt === iconVal) {
                $setInput.val(iconVal);
                $setRange.val(iconVal);
                moveEquiv();
                hideEquiv();
                return;
            }

            $setInput.val(numberCurInt);
            $setRange.val(numberCurInt);
            moveEquiv();

            if (numberCurInt !== iconVal) {
                window.requestAnimationFrame(step);
            }
            currentFrame++;
        }
        window.requestAnimationFrame(step);
    };

    const initEquiv = function () {
        rangeWidth = $setRange[0].getBoundingClientRect().width;
        windowWidth = Math.max(screen.width || 0);
        moveEquiv();
    };

    const showEquiv = function (ev, hide) {

        if( noEquiv ){
            return;
        }
        // if we're triggering this without a click, you may want to show the text, then remove it
        if (hide) {
            const nowHideAgain = function () {
                hideEquiv();
                $setEquivalent[0].removeEventListener('transitionend', nowHideAgain);
            };
            //hideEquivInstant(); doesn't work??
            $setEquivalent[0].addEventListener('transitionend', nowHideAgain, false);
        }
        $setEquivalent.addClass('Ge-Ny-Consumption-Range-range-equiv--active');
        $setRange.focus();
    };

    const dumbEquiv = function (ev) {
        $setEquivalentText.html('- - -');
    };

    const hideEquiv = function (ev) {
        $setEquivalent.removeClass('Ge-Ny-Consumption-Range-range-equiv--active');
    };

    const hideEquivInstant = function (ev) {
        $setEquivalent.css({ 'transition': 'all 0ms', 'transition-delay': '0ms' }).removeClass('Ge-Ny-Consumption-Range-range-equiv--active');
        setTimeout(function () {
            $setEquivalent.removeClass('Ge-Ny-Consumption-Range-range-equiv--instant').attr('style', '');
        }, 50);
    };

    const moveEquiv = function (ev) {
        
        if( noEquiv ){
            return;
        }

        const useVal = $setRange.val();
        const percent = (useVal - rangeMin) / (rangeMax - rangeMin);
        const distance = percent * (rangeWidth - 22);
        $setEquivalent.css({
            'transform': 'translate3d(' + distance + 'px,0,0)',
            '-webkit-transform': 'translate3d(' + distance + 'px,0,0)'
        });
        checkEquivWidth(distance);
    };

    const checkEquivWidth = function (distance) {
        const gutter = 10;
        const spaceEitherSide = ((windowWidth - rangeWidth) / 2);
        const leftEdgeOfEquiv = distance - (equivWidth / 2) + 10;
        const rightEdgeOfEquiv = distance + (equivWidth / 2) + 10;
        const distLeft = spaceEitherSide + leftEdgeOfEquiv;
        const distRight = spaceEitherSide + rightEdgeOfEquiv;
        const thumbWidth = (window.TOUCH_ENABLED ? 31 : 20);
        if (distLeft < gutter) {
            $setEquivalentShuttle.css({
                'transform': 'translateX(' + (-1 * distLeft + gutter) + 'px)',
                '-webkit-transform': 'translateX(' + (-1 * distLeft + gutter) + 'px)'
            });
            $setEquivalentArrow.css({
                'transform': 'translateX(' + (distLeft + gutter - thumbWidth / 2) + 'px)',
                '-webkit-transform': 'translateX(' + (distLeft + gutter - thumbWidth / 2) + 'px)'
            });
        } else if (distRight > (windowWidth - gutter)) {
            $setEquivalentShuttle.css({
                'transform': 'translateX(' + (-1 * (distRight - windowWidth) - gutter) + 'px)',
                '-webkit-transform': 'translateX(' + (-1 * (distRight - windowWidth) - gutter) + 'px)'
            });
            $setEquivalentArrow.css({
                'transform': 'translateX(' + (distRight - windowWidth - gutter + thumbWidth / 2) + 'px)',
                '-webkit-transform': 'translateX(' + (distRight - windowWidth - gutter + thumbWidth / 2) + 'px)'
            });
        } else {
            $setEquivalentShuttle.css({
                'transform': '',
                '-webkit-transform': ''
            });
            $setEquivalentArrow.css({
                'transform': '',
                '-webkit-transform': ''
            });
        }
    };

    const listenEquivalent = function (ev) {
        const val = 0; // TODO
        let txt = undefined; // TODO
        const equivSteps = []; //nyConsumptionEquiv.steps;
        equivSteps.every(function (step, index) {

            $setInput.removeClass('Ge-Ny-Consumption-field-total--active');
            if (val >= parseInt(rangeMax)) {
                txt = 'Ange förbrukning manuellt';
                // shift focus to input, but not if we're on a touch screen (that would open the software keyboard when the field is focused and everything goes to crap).
                if (!window.TOUCH_ENABLED) {
                    inputSelect();
                }
                // highlight the input field
                $setInput.addClass('Ge-Ny-Consumption-field-total--active');
                // ga
                app.trigger('beacon', 'consumption-top-limit');
            } else if (val < step.value) {
                txt = step.label;
                return false;
            } else {
                return true;
            }
        });
        if (txt) {
            $setEquivalentText.html(txt);
        }
    };

    return {
        init: init()
    };
};

slider.selector = selector;

export default slider;
